/**
 * Comments constants
 * Mirrors Flutter's AppConstants values from lib/domain/constants/app_constants.dart
 */
export const COMMENTS_CONSTANTS = {
  MAX_USER_POPULARITY_FOR_COMMENT: 100,
  DEFAULT_USER_POPULARITY_FOR_COMMENT: 0,
  DEFAULT_REPLY_POPULARITY_FOR_COMMENT: 3,
  DEFAULT_LIKE_POPULARITY_FOR_COMMENT: 1,
} as const;
